import { useApi } from 'arcway/lib/client'

export function useSession() {
  const session = useApi('/auth/session', undefined, {
    ws: false,
  })
  const data = session.data

  return {
    account: data?.account || null,
    accounts: data?.accounts || [],
    authenticated: data?.authenticated === true,
    error: session.error,
    loading: session.loading,
    mutate: session.mutate,
    user: data?.user || null,
  }
}
